/** Thin space between thousands, so a five-figure catalogue is readable at a glance. */
const groupDigits = (count: number) => String(count).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export default groupDigits;
